<template>
    <div class="widget">
        <div class="panel" v-if="!noTerm">
            <div class="panel-heading" v-if="submissionAssignmentIds">

            <span class="badge" v-if="alerts && alerts.length > 0">{{alerts.length}}</span>

            <h2>Course Alerts<i class="clippie fa fa-info-circle" v-tooltip="'Find your time sensitive course alerts below'"></i></h2>
                <div class="toggle-widget" @click="open=!open">
                    <i v-if="open===true" class="fa fa-minus"></i>
                    <i v-else class="fa fa-plus"></i>
                </div>
            </div>
            <div class="panel-body" v-show="open">
                <ul class="class-alerts sin-alert clearfix" v-if="localStorage.sinRequested == true && !sinSubmitted">
                    <li>
                        <router-link to="/sin">
                            <img src="./../../assets/img/bullhorn.png">
                            <div class="alert-text">                               
                                <span class="alert-name">Government Required Information</span>                                
                                 <br>{{sinDueDate | shortDate}}<br>
                            </div>
                        </router-link>
                    </li>
                </ul>
                <ul class="class-alerts clearfix" v-if="events && events.length > 0">
                    
                    <li
                    @click="setWeek(realCurrentWeek)"
                    v-for="alert in alerts" v-if="alert"
                    v-show="alert.type !== 'note' || (alert.type === 'note' && alert.completed !== true)"
                    >
                        <img v-if="alert.type==='assignment' && (submissionAssignmentIds.indexOf(alert.id) === -1 || alert.resubmission === true)" src="./../../assets/img/assignment-icon.png">
                        <img v-if="alert.type==='exercise'" src="./../../assets/img/excercise-icon.png">
                        <img v-if="alert.type==='note'" src="./../../assets/img/assignment-icon.png">
                        <router-link
                        v-if="alert.type==='assignment' && (submissionAssignmentIds.indexOf(alert.id) === -1 || alert.resubmission === true)"
                        :to="{name: 'videoPlayer',
                        params: {
                            courseId: alert.courseId,
                            instanceId: alert.instanceId,
                            videoId: alert.video.id
                            },
                        query: {term:currentTerm.id, week: alert.week, tab: 'assignment'}}">
                            <div class="alert-text">
                                <span class="alert-name">
                                 {{alert.name}}

                                 </span>
                                 <br>{{alert.dueDate | shortDate}}<br>
                                 <countdown :date="alert.dueDate"></countdown>
                            </div>
                        </router-link>

                        <router-link

                            v-if="alert.type==='exercise'"
                            :to="{name: 'videoPlayer',
                            params: {
                                courseId: alert.exercise.course,
                                instanceId: alert.exercise.instanceId,
                                videoId: alert.exercise.videoId
                                },
                            query:{term:currentTerm.id, week: realCurrentWeek, tab: 'exercise'}}">
                            <div class="alert-text">
                                <span class="alert-name">
                                 {{alert.exercise.title}}
                                 </span>
                                 <br>{{alert.dueDate | shortDate}}<br>
                                 <countdown :date="alert.dueDate"></countdown>
                            </div>
                        </router-link>

                        <router-link
                            v-if="alert.type==='note'"
                            :to="{name: 'mentorDashboard',
                            query:{note_id: alert.id}}">

                            <div class="alert-text">
                                <span class="alert-name">
                                 {{alert.title}}
                                 </span>
                                 <br>{{alert.dueDate | localShortDate}}<br>
                                 <countdown :date="alert.dueDate" :fast="true"></countdown>


                            </div>
                        </router-link>
                 </li>
             </ul>
             <p v-if="(!events || events.length === 0) && (!globalMentors || globalMentors.length === 0)">No course alerts at this time.</p>
                <ul v-if="courseAlerts && courseAlerts.length > 0" class="class-alerts clearfix path-alert">
                    <li v-for="alert in courseAlerts">

                        <a :href="alert.link">
                            <img src="./../../assets/img/bullhorn.png">
                            <div class="alert-text">
                                <span class="alert-name" v-if="alert.meetingId">Weekly Update</span>
                                <span class="alert-name" v-else>{{alert.name}}</span><br>
                                <span v-if="alert.meetingId">{{alert.dueDate | shortDate}}</span><span v-else>{{alert.dueDate | localShortDate}}</span><br>
                                <countdown :date="alert.dueDate" :fast="true"></countdown>
                            </div>
                        </a>
                    </li>
                </ul>
                <ul v-if="checkins && checkins.length > 0" class="class-alerts clearfix path-alert">
                    <li v-for="checkin in checkins">

                         <router-link
                         :to="{name: 'mentorCheckins', query: {id: checkin.id}}">
                                <img src="./../../assets/img/bullhorn.png">
                                <div class="alert-text">
                                    <span class="alert-name" v-if="checkin.meetingId === 0">Check-in for {{checkin.dueDate | monthAndDay}}</span>
                                    <span class="alert-name" v-else>Check-in for Week {{checkin.week}}</span>
                                    <br>{{checkin.dueDate | checkinDate}}<br>
                                    <span class="overdue" v-if="isOverdue(checkin.dueDate)">Overdue</span>
                                    <countdown v-else :date="checkin.dueDate" :fast="true"></countdown>
                                </div>
                        </router-link>
                    </li>
                </ul>
                <ul v-if="globalMentors && globalMentors.length > 0" class="class-alerts clearfix path-alert">
                    <li v-for="mentor in globalMentors">
                         <a href="#" @click.prevent="selectedGlobalMeeting = mentor.global_meeting.id">
                                <img src="./../../assets/img/bullhorn.png">
                                <div class="alert-text">
                                    <span class="alert-name"
                                        :class="{'blue': isParticipant(mentor.global_meeting.global_meeting_participants)}"
                                    >
                                    <span v-if="mentor.roles.includes('Recruiter')">Recruiter Meeting, </span>
                                    <span v-else>Global Mentorship, </span>
                                    {{mentor.firstName}} {{mentor.lastName}},  <span v-if="mentor.roles.includes('Recruiter')">{{mentor.global_mentor_profile.company}}</span><span v-else>{{mentor.mentor_profile.position}}</span></span><br>
                                    <span class="alert-name" :class="{
                                        'red':mentor.global_meeting.global_meeting_participants.length >= mentor.global_meeting.maxParticipants}">
                                        {{mentor.global_meeting.global_meeting_participants.length}} / {{mentor.global_meeting.maxParticipants}}
                                    </span>
                                    <br>{{mentor.global_meeting.startTime | shortDate}}<br>
                                    <countdown :date="mentor.global_meeting.startTime" :fast="true"></countdown>
                                </div>
                      
                        </a>
                    </li>
                </ul>


         </div>
     </div>
     <div v-else class="panel">
        <div class="panel-heading"><h2>Class Alerts</h2></div>
        <div class="panel-body"><p>Term has not yet started</p></div>
    </div>

    <global-meeting-signup @closeModal="selectedGlobalMeeting=null;getGlobalMeetings()" v-if="selectedGlobalMeeting" :meetingId="selectedGlobalMeeting"></global-meeting-signup>


 </div>

</template>


<script>

    import meetings from '../../services/meetings';
    import assignments from '../../services/assignments';
    import exercises from '../../services/exercises';
    import submissions from '../../services/submissions';
    import journeys from '../../services/journeys';
    import checkins from '../../services/checkins';
    import weeklyUpdates from '../../services/weekly-updates';
    import globalMeetings from '../../services/global-meetings';

    import countdown from '../reusable/countdown/CountdownTimer.vue';
    import GlobalMeetingSignup from './GlobalMeetingSignup.vue';

    import moment from 'moment';
    import toastr from 'toastr';

    export default {
        data() {
            return {
                week:null,
                open:true,
                pathDueDate: null,
                submissions:[],
                submissionAssignmentIds: [],
                noTerm: false,
                mustPickPath: false,
                mustPickMentor:false,
                mentorDueDate: null,
                mustPickAlumniSoftware: false,
                alumniSoftwareDueDate: null,
                pathType:null,
                mustPickAlumniSoftware: false,
                alumniSoftwareDueDate:null,
                events: [],
                courseAlerts:null,
                checkins:null,
                globalMentors: null,
                selectedGlobalMeeting: null,
                sinSubmitted: false
            }
        },
        components: {
            countdown,
            GlobalMeetingSignup,
        },
        mounted() {
            var self = this;
            let userTimezone = moment.tz.guess();

            if (this.$route.query.global_meeting) {
                this.selectedGlobalMeeting = parseInt(this.$route.query.global_meeting);
            }
            if (this.roles.includes('Student') || this.roles.includes('Supervisor') || this.roles.includes('CampusStudent')) {
                this.getAlerts();
            } else {

            }

            if (localStorage.sinSubmitted == 'true') this.sinSubmitted = true;

            this.sinDueDate = moment().month(0+12).date(31).hour(23).minute(59).second(59).toDate();
           

            // this.localDirectorMeetingDate = moment.tz('2018-04-16 19:30:00', 'America/Vancouver').tz(userTimezone).toDate();
            this.pathDueDate = moment('2019-05-10').tz('America/Vancouver').endOf('day').toDate();

            this.alumniSoftwareDueDate = moment('2019-01-14').tz('America/Vancouver').endOf('day').toDate();
            if (localStorage.terms.includes('807826')) {
                this.mustPickPath = true;
                this.pathType = 'path';
            }

            if (localStorage.terms.split(',').length === 4) {
                this.mustPickAlumniSoftware = true;
            }

            if (localStorage.terms.split(',').length === 2 && localStorage.path == '6644') {
                this.mustPickPath = true;
                this.pathType = 'focus';
            }


            if (localStorage.terms.split(',').length === 4) {
                this.mustPickAlumniSoftware = true;
            }

            if (localStorage.roles.includes('CampusStudent') || localStorage.terms.split(',').length === 3) {
                this.mustPickMentor = true;
            }
            
            const MENTORSHIP_GROUP = 22;
            let studentGroups = JSON.parse(JSON.stringify(localStorage.group.split(',')));

            if (!Array.isArray(studentGroups)) studentGroups = [studentGroups];
            if (Array.isArray(studentGroups)) studentGroups = studentGroups.map(g => parseInt(g));

            if (this.roles.includes('Student') || this.roles.includes('CampusStudent')) {
                self.getGlobalMeetings();
            }

            if (!localStorage.roles.includes('CampusStudent')) {

                var checkForTermData = window.setInterval(termWeeksLoaded, 500);
            }

            if (localStorage.roles.includes('CampusStudent') || localStorage.transitioned === 'true') {
                self.getCheckins();
            }

            function termWeeksLoaded() {

                if (localStorage.terms === 'null') {
                    clearInterval(checkForTermData);
                    self.noTerm = true;
                }

                var week = self.realCurrentWeek;

                if (!week) return;

                if (week && self.$store.getters.courses.length > 0) {
                    self.week = parseInt(week);
                    self.getAssignments();
                    clearInterval(checkForTermData);
                }
                if (week.toString() === '0' && self.$store.getters.courses.length > 0) {
                    self.week = parseInt(week);
                    self.getAssignments();
                    clearInterval(checkForTermData);
                }


                const localRoles = localStorage.roles || [];
                const localTerms = localStorage.terms || '';

                if (week && (!localRoles.includes('Student') || localTerms.split(',').length > 3)) {
                    self.week = parseInt(week);
                    self.getAssignments();
                    clearInterval(checkForTermData);
                    self.getCheckins();

                }


            }


            this.$bus.$on('sinSubmitted', function() {
               self.sinSubmitted = true;
               self.$forceUpdate();
            });

            this.$bus.$on('student_submission', function() {
                self.events = [];
                var week = self.$store.state.realCurrentWeek;
                self.week = parseInt(week) + 1;
                self.getAssignments();
            });

            this.$bus.$on('mentorNoteAdded', function(note) {
                let exists = self.events.findIndex(function(e) { return e.id === note.id});

                if (exists > -1) {
                    self.$set(self.events, exists, note);
                } else {
                    self.events.push(note);
                }

            });

           this.$bus.$on('checkin', (id) => {
                let exists = this.checkins.findIndex(function(e) { return e.id === id});
                if (exists > -1) {
                    this.checkins.splice(exists,1);
                }

            });

            this.$bus.$on('reloadAlerts', () => {
                this.getAlerts();
            });
        },
        methods: {
            isParticipant(participants) {
                const userId = parseInt(localStorage.user_id);

                const participant = participants.find((p) => { return p.userId === userId; });
                
                if (participant && !participant.waitListed) {
                    return true;
                }
            },
            setWeek(week) {
                 var data = {
                    type: 'currentWeek',
                    data: week - 1
                }
                this.$store.dispatch('populate', data);
            },
            getGlobalMeetings() {
                globalMeetings.get().then((response)=> {
                    this.globalMentors = response.data.globalMentors;
                });
            },

            getCheckins() {
                checkins.get().then((response)=> {
                    const now = new Date();
                    const CAMPUS_ALUMNI_GROUP = 22;
                    const CAMPUS_MEMBERSHIP_GROUP = 20;
                    const groups = localStorage.group.split(',').map(g => parseInt(g));
                    if (response.checkins) {
                        this.checkins = response.checkins.filter((c)=> {
                            if (groups.includes(CAMPUS_ALUMNI_GROUP) || groups.includes(CAMPUS_MEMBERSHIP_GROUP)) {
                                return new Date(c.startDate) < now && !c.checkin;
                            } else {
                                if (c.checkin) return false;
                                if (c.meetingId && new Date(c.meetingTime) < now) return true;                                
                                return new Date(c.startDate) < now;
                            }
                        });
                    } else {
                        this.checkins = [];
                    }
                });
            },
            isOverdue(d) {
                return new Date(d) < new Date();
            },
            async getAlerts() {

                let journeyAlerts = await journeys.getAlerts();

                if (journeyAlerts.data.success === true) {
                    journeyAlerts = journeyAlerts.data.alerts;

                    if (localStorage.path && localStorage.path == '9200') {
                        journeyAlerts = journeyAlerts.filter(j => j.actionName !== 'pickPath');
                    }

                } else {
                   // toastr.error('Error getting journey');
                    journeyAlerts = [];
                }

                let updateAlerts = await weeklyUpdates.getAlerts();
                if (updateAlerts.data.success === true) {
                    updateAlerts = updateAlerts.data.alerts
                                    .filter((a)=> {
                                        return !a['weekly_update.id'];
                                    }).map((a)=> {
                                        a.link = '/#/weekly-updates';
                                        return a;
                                    });

                } else {
                   // toastr.error('Error getting weekly updates');
                    updateAlerts = [];
                }

                if (!journeyAlerts) journeyAlerts = [];

                this.courseAlerts = journeyAlerts.concat(updateAlerts).sort((a,b)=> {
                    return new Date(a.dueDate) - new Date(b.dueDate);
                });


            },
            getSubmissions() {
                var self = this;
                submissions.getMine(this).then(function(response) {
                    self.submissions = response.data.submissions;
                    self.submissionAssignmentIds = response.data.submissions.map(function(s) { return s.assignmentId });

                });
            },
            getAssignments: async function() {
                var self = this;
                var week = self.week;

                if (!week) return;

                var now = new Date();
                self.events = [];


                if (!this.$store.getters.currentTerm || new Date(this.$store.getters.currentTerm.endDate) < new Date()) {
                    return;
                }

                let myCourses = self.$store.getters.courses.filter(function(c) {                
                    return (!c.associated.courseSets || c.associated.courseSets.length === 0) || c.associated.courseSets.includes(self.currentTerm.selectedCourseSet) || !self.currentTerm.selectedCourseSet;
                }).map(function(c) {
                    return parseInt(c.id);
                });


                let response = await assignments.getAll(this, null, myCourses);
                if (response.data.success === true) {                    
                  
                    var weeklyAssignments = response.data.assignments.filter(function(a) {

                        return myCourses.includes(a.instanceId) || myCourses.includes(parseInt(a.instanceId))
                    }).map(function(a) {
                        a.type = 'assignment';
                        return a;
                    });


                    self.events = self.events.concat(weeklyAssignments);
                    self.$store.dispatch('concat', {type: 'timelineEvents', data: weeklyAssignments});
                    self.getSubmissions();
                }


                myCourses = self.$store.getters.courses.filter(function(c) {
                    return !c.associated.courseSets || c.associated.courseSets.includes(self.currentTerm.selectedCourseSet) || !self.currentTerm.selectedCourseSet;
                }).map(function(c) {
                    return parseInt(c.course);
                });


                exercises.getForWeek(this, this.currentTerm.id, week).then(function(response) {

                    if (response.data.success === true) {

                        var exercises = response.data.exercises.map(function(e) {
                            e.type = 'exercise';

                            if (!e.exercise) return;

                            let index = myCourses.findIndex(function(c) { return c == e.exercise.course});

                            if (index > -1) {

                                if (e.exercise.dueDate) {
                                    e.dueDate = e.exercise.dueDate;
                                } else {
                                    e.dueDate = moment().tz('America/Vancouver').endOf('week').subtract(1,'day').toDate();
                                }
                                return e;
                            }
                        });

                        exercises = exercises.filter(function(e){return e});

                        self.$store.dispatch('concat', {type: 'timelineEvents', data: exercises});

                        exercises = exercises.filter(function(e) {
                            if (e && e.exercise) {
                                return e.exercise.exercise_hand_ins.length === 0;
                            }
                        });

                        self.events = self.events.concat(exercises);

                    }

                });
            },
        },
        watch: {
            'currentTerm.selectedCourseSet'(courseSet) {
                this.getAssignments();
            },

        },
        computed: {
            roles() {
                return JSON.parse(localStorage.roles.split(','));
            },
            currentTerm() {
                return this.$store.getters.currentTerm;
            },
            realCurrentWeek() {
                return this.$store.state.realCurrentWeek + 1;
            },
            alerts() {
                if (!this.submissions) return;
                let self = this;
                let events = this.events
                .map(function(a) {

                    if (a.startTime) a.alertDate = a.startTime;
                    if (a.dueDate) a.alertDate = a.dueDate;
                    return a;
                })
                .filter(function(a) {
                    if (a.type === 'assignment') {
                        if (a.isFinalProject === true) {

                            // const now = moment(a.dueDate).add(1,'second').toDate();
                            const now = new Date()
                            const oneWeekAfterDueDate = moment(a.dueDate).add(1,'week').toDate();
                            const dueDate = new Date(a.dueDate);

                            if (now > dueDate && now < oneWeekAfterDueDate && self.submissionAssignmentIds.indexOf(a.id) > -1) {

                                const numberOfSubmissions = self.submissions.filter((s)=>{
                                    return s.assignmentId === a.id;
                                });

                                const alreadyResubmitted = self.submissions.find((s)=>{
                                    if (s.assignmentId !== a.id) {
                                        return false;
                                    }
                                    const created = new Date(s.createdAt);
                                    return created > dueDate;
                                });

                                if (numberOfSubmissions > 1 && alreadyResubmitted) {
                                    return false;
                                }
                                
                                a.resubmission = true;
                                a.dueDate = oneWeekAfterDueDate;
                                a.name = 'Final Project Resubmission (Optional)';
                                return true;
                            } else {
                                return (new Date(a.alertDate) > new Date()) && (self.submissionAssignmentIds.indexOf(a.id) === -1);
                            }

                        } else {
                            return (new Date(a.alertDate) > new Date()) && (self.submissionAssignmentIds.indexOf(a.id) === -1);
                        }
                    }
                    if (a.type === 'note') {
                        return (new Date(a.alertDate) > new Date());
                    }
                    else if (a.type === 'exercise') {
                        return (new Date(a.alertDate) > new Date()) && (a.exercise.exercise_hand_ins.length === 0);
                    }
                })
                .sort(function(a, b) {
                     return a.alertDate > b.alertDate;
                });


                return events;
            }
        }
    }
</script>


<style  lang="scss" scoped>
.overdue {
    color:red;
}
.panel.workshops .panel-body {
    padding-top:2rem;
    padding-bottom:1rem;
}
    .panel-body p {
        text-align:center;
        padding-top:2rem;
    }
    .class-alerts {
        padding-bottom: 0rem;
    }
    .path-alert {
        padding-top: 0!important;
        padding-bottom:0rem;
    }
    .sin-alert {
        img {
            position: relative;
            left:.5rem;
        }
        .alert-text {
            padding-left:2rem;
        }
    }
    .panel-body > ul:last-child {
        padding-bottom:2rem;
    }
    a {
        color:inherit;
    }
    ul {
        clear:both;
        padding-bottom:2rem;
        padding-top:1.5rem;
    }
    li {
        padding: 1rem 1rem 1rem 2rem;
        clear:both;
    }
    h5 {
        margin-bottom:0;
    }
    img, .alert-text {
       display:block;
       float:left;
   }
   .alert-text {
        padding-left:1rem;
        max-width: 80%;
    }
    .alert-name {
        color:white;
    }
    .red {
        color:red;
    }
    .blue {
        color:#3cf;
    }
</style>



// WEBPACK FOOTER //
// ClassAlerts.vue?2050cb09